// Change this
const module = 'centers'

import {checkAuth} from "@/services/auth";

// Change this
import Index from '@/views/centers/Index'
import Create from '@/views/centers/Create'
import Edit from '@/views/centers/Edit'
import Media from '@/views/centers/Media'
import Info from '@/views/centers/Info'
import Configurations from '@/views/centers/Configurations'
// import Fields from '@/views/centers/Fields'

var prefix = '/'

export default [
    {
        path: prefix+`${module}/`,
        name: `${module}Index`,
        component: Index,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/create`,
        name: `${module}Create`,
        component: Create,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/edit/:id`,
        name: `${module}Edit`,
        component: Edit,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/media/:id`,
        name: `${module}Media`,
        component: Media,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/info/:id`,
        name: `${module}Info`,
        component: Info,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/configurations/:id`,
        name: `${module}Configurations`,
        component: Configurations,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    // {
    //     path: prefix+`${module}/fields/:id`,
    //     name: `${module}Fields`,
    //     component: Fields,
    //     beforeEnter (to,from,next){
    //         checkAuth().then( response =>{
    //                 if(response){
    //                     next();
    //                 }else{
    //                     next('/login');
    //                 }
    //             }
    //
    //         )
    //     }
    // },
]
